module.exports = __webpack_public_path__ + "img/marker_espais.7feb5b46.svg";